import { useQuery } from "@tanstack/react-query";
import { ColumnsType } from "antd/es/table"
import dayjs from "dayjs"
import { getProgramBookingInfoByProgramBookingId } from "../../../../../service/programBooking";
import { EProgramBookingStatus } from "../../../../wellnessProgram/program/booking/model";

export interface IProgramBookingInfo {
    id: number;
    memberName: string;
    programTitle: string;
    programRefundNotiHtml: string;
    targetDateTime: string;
    programBookingSelectOptionList: IProgramBookingSelectOptionList[];
    programBookingSubjectOptionList: IProgramBookingSubjectOption[];
    paidAmount: number;
    paidDateTime: string;
    requestCancelDateTime: string;
    status: string;
    tossPayId: number;
    orderId: string;
    totalAmount: number;
    availableRefundAmount: number;
    tossPayCancelList: ITossPayCancel[];
    programBookingStatusHistoryList: IProgramBookingStatusHistory[];
    programBookingMemoList: IProgramBookingMemo[];
}

interface IProgramBookingSubjectOption {
    id: number
    programSubjectOptionId: number
    content: string
    programSubjectOptionName: string
}
interface IProgramBookingSelectOptionList {
    id: number
    programSelectOptionId: number
    programSelectOptionItemIdList: number[]
    programSelectOptionName: string
    programSelectOptionItemList: IProgramSelectOptionItemList[]
}
interface IProgramSelectOptionItemList {
    id: number
    name: string
}
interface IProgramBookingStatusHistory {
    id: number;
    createdDate: string;
    memberName: string;
    content: string;
}

interface IProgramBookingMemo {
    id: number;
    memo: string;
    createdDate: string;
    memberName: string;
}
interface ITossPayCancel {
    id: number;
    cancelAmount: number;
    cancelReason: string;
    canceledAt: string;
}

const cancelManageHistoryColumns: ColumnsType<IProgramBookingStatusHistory> = [
    {
        title: '변경일시',
        dataIndex: 'createdDate',
        render: q => dayjs(q).format('YYYY.MM.DD HH:mm:ss')
    },
    {
        title: '변경자',
        dataIndex: 'memberName'
    },
    {
        title: '변경 내용',
        dataIndex: 'content'
    },
]

const cancelManageMemeColumns: ColumnsType<IProgramBookingMemo> = [
    {
        title: 'No',
        dataIndex: 'id'
    },
    {
        title: '내용',
        dataIndex: 'memo'
    },
    {
        title: '생성시간',
        dataIndex: 'createdDate',
        render: q => dayjs(q).format('YYYY.MM.DD HH:mm:ss')
    },
    {
        title: '작성자',
        dataIndex: 'memberName'
    },
]

const getNextAvailableStatusForCancelManage = (status?: EProgramBookingStatus) => {
    switch (status) {
        case EProgramBookingStatus.COMPLETE:
            return [EProgramBookingStatus.COMPLETE, EProgramBookingStatus.REQUEST_CANCEL];
        case EProgramBookingStatus.REQUEST_CANCEL:
            return [EProgramBookingStatus.REQUEST_CANCEL, EProgramBookingStatus.COMPLETE, EProgramBookingStatus.REFUND];
        case EProgramBookingStatus.CANCEL:
            return [EProgramBookingStatus.CANCEL];
        case EProgramBookingStatus.REFUND:
            return [EProgramBookingStatus.REFUND,];
        default:
            return [];
    }
}

const useGetProgramBookingInfoByProgramBookingId = <T,>(id: number, programBookingInfoField?: any) => {
    const query = useQuery({
        queryKey: ['getProgramBookingInfoByProgramBookingId', id],
        queryFn: () => getProgramBookingInfoByProgramBookingId<T>(id, programBookingInfoField),
        enabled: !!id,
        select: (res) => res.data.data.getProgramBookingInfoByProgramBookingId
    })

    return query
}



export { cancelManageHistoryColumns, cancelManageMemeColumns, getNextAvailableStatusForCancelManage, useGetProgramBookingInfoByProgramBookingId }